/* STATUS / AGENT NOTES (2026-09-04): Agent-owned cart-native PICK4 add, split-line-safe aggregate quantity controls and device switching, discount, exact cart-line discount display, design-card price isolation, checkout-matched orange Select/Adding states with a simplified darker selected quantity control, post-add keyboard focus restoration, selected-phone confirmation, initial device-and-family restoration from existing deal-cart lines, faster drawer refresh, loading feedback, contextual result copy, catalog pagination, phone dialog, full-cart preview, checkout-style image zoom, builder-aware guided mobile selection, focus-safe guide hiding, live variant-driven case-type availability, product-scoped inline device switching with an explicit underlined action, device-specific preview images, smooth page navigation, actionable savings progress copy, transparent popular-design Wingmate hero behavior, progressive phone-model gating, corrected floral filtering, simplified cart copy, a configurable three-case buy-two-get-one threshold, and Gender_* compatibility for the existing audience controls. */
/* Agent START: scoped PICK4 builder behavior */
(function () {
  'use strict';

  function initPick4(root) {
    if (!root || root.dataset.pick4Ready === 'true') return;
    root.dataset.pick4Ready = 'true';

    var catalogNode = root.querySelector('[data-pick4-catalog]');
    var catalog;
    try { catalog = JSON.parse(catalogNode ? catalogNode.textContent : '{"products":[]}'); }
    catch (error) { catalog = { products: [] }; }

    var products = Array.isArray(catalog.products) ? catalog.products.filter(function (product) {
      return product && Array.isArray(product.variants) && product.variants.length;
    }) : [];
    var families = ['Wingmate', 'Wingman', 'Moneymate', 'MagCase'];
    var deviceSelect = root.querySelector('[data-pick4-device]');
    var deviceTrigger = root.querySelector('[data-pick4-device-trigger]');
    var deviceValue = root.querySelector('[data-pick4-device-value]');
    var deviceSelectionCheck = root.querySelector('[data-pick4-device-selection-check]');
    var deviceDialog = root.querySelector('[data-pick4-device-dialog]');
    var deviceDialogTitle = root.querySelector('[data-pick4-device-title]');
    var closeDeviceDialog = root.querySelector('[data-pick4-close-device]');
    var deviceOptions = root.querySelector('[data-pick4-device-options]');
    var familyTiles = root.querySelector('[data-pick4-family-tiles]');
    var postFamily = root.querySelector('[data-pick4-post-family]');
    var grid = root.querySelector('[data-pick4-grid]');
    var drawerGrid = root.querySelector('[data-pick4-drawer-grid]');
    var empty = root.querySelector('[data-pick4-empty]');
    var drawerEmpty = root.querySelector('[data-pick4-drawer-empty]');
    var resultsLabel = root.querySelector('[data-pick4-results-label]');
    var resultsBar = root.querySelector('[data-pick4-results-bar]');
    var openDrawer = root.querySelector('[data-pick4-open-drawer]');
    var pagination = root.querySelector('[data-pick4-pagination]');
    var pageStatus = root.querySelector('[data-pick4-page-status]');
    var loadMore = root.querySelector('[data-pick4-load-more]');
    var drawer = root.querySelector('[data-pick4-drawer]');
    var closeDrawer = root.querySelector('[data-pick4-close-drawer]');
    var drawerCount = root.querySelector('[data-pick4-drawer-count]');
    var zoomDialog = root.querySelector('[data-pick4-zoom-dialog]');
    var zoomImage = root.querySelector('[data-pick4-zoom-image]');
    var closeZoomDialog = root.querySelector('[data-pick4-close-zoom]');
    var selectedLines = root.querySelector('[data-pick4-lines]');
    var otherGroup = root.querySelector('[data-pick4-other-group]');
    var otherLines = root.querySelector('[data-pick4-other-lines]');
    var otherOverflow = root.querySelector('[data-pick4-other-overflow]');
    var cartCount = root.querySelector('[data-pick4-cart-count]');
    var count = root.querySelector('[data-pick4-count]');
    var progress = root.querySelector('[data-pick4-progress]');
    var progressBar = root.querySelector('[data-pick4-progress-bar]');
    var freeUpdate = root.querySelector('[data-pick4-free-update]');
    var totals = root.querySelector('[data-pick4-totals]');
    var subtotalLabel = root.querySelector('[data-pick4-subtotal-label]');
    var subtotal = root.querySelector('[data-pick4-subtotal]');
    var savings = root.querySelector('[data-pick4-savings]');
    var otherTotalRow = root.querySelector('[data-pick4-other-total-row]');
    var otherTotalLabel = root.querySelector('[data-pick4-other-total-label]');
    var otherTotal = root.querySelector('[data-pick4-other-total]');
    var pay = root.querySelector('[data-pick4-pay]');
    var cartButton = root.querySelector('[data-pick4-cart-button]');
    var errorBox = root.querySelector('[data-pick4-error]');
    var live = root.querySelector('[data-pick4-live]');
    var mobileBar = root.querySelector('[data-pick4-mobile-bar]');
    var mobileStepTrack = root.querySelector('[data-pick4-mobile-step-track]');
    var mobileCount = root.querySelector('[data-pick4-mobile-count]');
    var mobileProgress = root.querySelector('[data-pick4-mobile-progress]');
    var mobilePreviews = root.querySelector('[data-pick4-mobile-previews]');
    var reviewButton = root.querySelector('[data-pick4-review]');
    var heroCta = root.querySelector('.scooch-pick4__hero-cta');
    var builderShell = root.querySelector('.scooch-pick4__builder-shell');
    var familyPicker = root.querySelector('.scooch-pick4__family-picker');
    var heroCases = root.querySelector('[data-pick4-hero-cases]');
    var searchInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pick4-search]'));
    var cartEnabled = root.dataset.cartEnabled === 'true';
    var discountCode = root.dataset.discountCode || 'BUY2GET1';
    // Agent START: keep every shopper-facing deal threshold tied to the section contract.
    var dealQuantity = Math.max(1, Number(root.dataset.dealQuantity) || 3);
    // Agent END: centralized deal quantity.
    var rootUrl = root.dataset.rootUrl || '/';
    var currency = root.dataset.currency || 'USD';
    var storageKey = 'scooch-pick4-v3-' + (root.dataset.sectionId || 'builder');
    var ownerProperty = '_scooch_pick4';
    var ownerValue = 'PICK4';
    var eligibleProductIds = products.reduce(function (lookup, product) {
      lookup[String(product.id)] = true;
      return lookup;
    }, Object.create(null));
    var state = {
      device: '', family: '', style: 'all', query: '', lines: [], otherLines: [],
      visibleLimit: 12, pendingVariantId: '',
      cartBusy: false, discountApplicable: false,
      foreignCaseConflict: false, cartTotal: 0, cartItemCount: 0
    };
    var freeUpdateTimer = 0;
    var externalCartRefreshTimer = 0;
    var dispatchingCartEvent = false;
    var builderObserver = null;
    var builderIntersecting = false;
    var mobileBarPendingHide = false;
    var deviceChangeTargetKey = '';
    var deviceChangeTargetProductId = '';
    var deviceChangeTargetDesign = '';
    var deviceReturnFocus = null;
    var zoomReturnFocus = null;
    var initialCartSelectionApplied = false;

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: currency, maximumFractionDigits: 2
        }).format((Number(cents) || 0) / 100);
      } catch (error) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
    }

    function escapeHtml(value) {
      var node = document.createElement('div');
      node.textContent = value == null ? '' : String(value);
      return node.innerHTML;
    }

    function announce(message) {
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = message; }, 20);
    }

    // Agent START: reveal the fixed mobile guide only after the shopper reaches the builder.
    function applyBuilderActive() {
      if (!mobileBar) return;
      if (!builderIntersecting && mobileBar.contains(document.activeElement)) {
        mobileBarPendingHide = true;
        return;
      }
      mobileBarPendingHide = false;
      if (root.classList.contains('is-builder-active') !== builderIntersecting) root.classList.toggle('is-builder-active', builderIntersecting);
    }

    function setBuilderActive(active) {
      builderIntersecting = active;
      applyBuilderActive();
    }

    function handleMobileBarFocusOut() {
      if (!mobileBarPendingHide) return;
      window.setTimeout(function () {
        if (!mobileBar.contains(document.activeElement)) applyBuilderActive();
      }, 0);
    }

    function handlePick4SectionUnload(event) {
      if (!event.target || (event.target !== root && !event.target.contains(root))) return;
      if (builderObserver) builderObserver.disconnect();
      root.classList.remove('is-builder-active');
      mobileBar.removeEventListener('focusout', handleMobileBarFocusOut);
      document.removeEventListener('shopify:section:unload', handlePick4SectionUnload);
    }

    function initializeMobileBarVisibility() {
      if (!mobileBar || !builderShell) return;
      if (!('IntersectionObserver' in window)) {
        setBuilderActive(true);
        return;
      }
      builderObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry) setBuilderActive(entry.isIntersecting);
      // Agent: the 80px inset prevents the guide from flapping at the mobile fold boundary.
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      builderObserver.observe(builderShell);
      mobileBar.addEventListener('focusout', handleMobileBarFocusOut);
      document.addEventListener('shopify:section:unload', handlePick4SectionUnload);
    }
    // Agent END: builder-aware mobile guide visibility.

    function saveState() {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({
          device: state.device,
          family: state.family,
          style: state.style,
          query: state.query
        }));
      } catch (error) {}
    }

    // Agent START 2026-09-04: Keep existing audience-filter tokens while Shopify tags move from Style_* to Gender_*.
    function normalizedTag(tag) {
      var sourceTag = String(tag || '');
      if (/^Gender_Men$/i.test(sourceTag)) return 'menspicks';
      if (/^Gender_Women$/i.test(sourceTag)) return 'womenspicks';
      return sourceTag.replace(/^Style_/i, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }
    // Agent END 2026-09-04: Gender taxonomy compatibility for PICK4 audience filters.

    function getVariant(product, device) {
      return product.variants.find(function (variant) {
        return variant && variant.available !== false && variant.device === device;
      }) || null;
    }

    // Agent START: derive case-type availability from real standalone variants for the selected phone.
    function availableFamiliesForDevice(device) {
      if (!device) return families.slice();
      return families.filter(function (family) {
        return products.some(function (product) {
          return product.family === family && !!getVariant(product, device);
        });
      });
    }

    function reconcileFamilySelection() {
      if (!state.device && state.family) {
        var prematureFamily = state.family;
        state.family = '';
        state.style = 'all';
        state.query = '';
        state.visibleLimit = 12;
        return prematureFamily;
      }
      if (!state.family || availableFamiliesForDevice(state.device).indexOf(state.family) !== -1) return '';
      var unavailableFamily = state.family;
      state.family = '';
      state.style = 'all';
      state.query = '';
      state.visibleLimit = 12;
      return unavailableFamily;
    }
    // Agent END: live variant-driven case-type availability.

    // Agent START: use one reduced-motion-safe behavior for every intentional in-page move.
    function scrollToPick4(target, block) {
      if (!target) return;
      window.requestAnimationFrame(function () {
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: block || 'start'
        });
      });
    }
    // Agent END: consistent smooth PICK4 page navigation.

    // Agent START: keep every PICK4 preview matched to the selected phone variant.
    function previewImage(product, variant) {
      return variant && variant.image ? variant.image : (product && product.image ? product.image : '');
    }
    // Agent END: device-specific PICK4 preview image helper.

    // Agent START: checkout-style image zoom with high-resolution Shopify CDN images and focus restoration.
    function highResolutionImage(src) {
      return String(src || '').replace(/([?&])width=\d+/, '$1width=1200');
    }

    function openImageZoom(trigger) {
      if (!zoomDialog || !zoomImage || !trigger) return;
      var cardImage = trigger.closest('.scooch-pick4__design-image');
      var image = cardImage && cardImage.querySelector('img');
      if (!image) return;
      zoomReturnFocus = trigger;
      zoomImage.src = highResolutionImage(image.currentSrc || image.src);
      zoomImage.alt = image.alt || '';
      if (!zoomDialog.open) zoomDialog.showModal();
    }

    function closeImageZoom() {
      if (zoomDialog && zoomDialog.open) zoomDialog.close();
    }
    // Agent END: checkout-style image zoom behavior.

    function decorateProduct(product, variant) {
      var tags = Array.isArray(product.tags) ? product.tags : [];
      var normalizedTags = tags.map(normalizedTag);
      return {
        product: product,
        variant: variant,
        normalizedTags: normalizedTags,
        isSale: tags.indexOf('Badge_Sale') !== -1 || Number(variant.compareAt) > Number(variant.price),
        isLimited: tags.indexOf('Badge_LimitedEdition') !== -1,
        isNew: tags.indexOf('Badge_New') !== -1
      };
    }

    function availableDesigns() {
      if (!state.device || !state.family) return [];
      return products.map(function (product) {
        var variant = getVariant(product, state.device);
        return variant ? decorateProduct(product, variant) : null;
      }).filter(Boolean).filter(function (item) {
        if (item.product.family !== state.family) return false;
        if (state.style === 'sale' && !item.isSale) return false;
        if (state.style === 'limited' && !item.isLimited) return false;
        if (state.style !== 'all' && state.style !== 'sale' && state.style !== 'limited' && item.normalizedTags.indexOf(state.style) === -1) return false;
        if (state.query) {
          var haystack = (item.product.design + ' ' + item.product.family + ' ' + item.product.title).toLowerCase();
          if (haystack.indexOf(state.query.toLowerCase()) === -1) return false;
        }
        return true;
      });
    }

    // Agent START: Shopify can split one discounted variant into paid and free lines; keep that pricing detail out of builder quantities.
    function groupIdentity(variantId, family, device, design) {
      return [ownerValue, variantId, family, device, design].map(function (value) {
        return String(value == null ? '' : value);
      }).join('\u0000');
    }

    function lineGroupKey(line) {
      return groupIdentity(line.variantId, line.family, line.device, line.design);
    }

    function cartItemGroupKey(item) {
      var properties = item && item.properties ? item.properties : {};
      return groupIdentity(
        item && item.variant_id,
        properties._scooch_pick4_family,
        properties._scooch_pick4_device,
        properties._scooch_pick4_design
      );
    }

    function rawLinesForGroup(line) {
      if (!line) return [];
      var groupKey = line.groupKey || lineGroupKey(line);
      return state.lines.filter(function (candidate) { return lineGroupKey(candidate) === groupKey; });
    }

    function aggregateLines(lines) {
      if (!lines.length) return null;
      var representative = lines[0];
      return Object.assign({}, representative, {
        groupKey: lineGroupKey(representative),
        quantity: lines.reduce(function (sum, line) { return sum + Math.max(0, Number(line.quantity) || 0); }, 0),
        originalLinePrice: lines.reduce(function (sum, line) {
          var value = Number(line.originalLinePrice);
          return sum + (Number.isFinite(value) ? value : line.price * line.quantity);
        }, 0),
        finalLinePrice: lines.reduce(function (sum, line) {
          var value = Number(line.finalLinePrice);
          return sum + (Number.isFinite(value) ? value : line.price * line.quantity);
        }, 0),
        rawLines: lines.slice()
      });
    }

    function groupedLines() {
      var groups = Object.create(null);
      var order = [];
      state.lines.forEach(function (line) {
        var key = lineGroupKey(line);
        if (!groups[key]) {
          groups[key] = [];
          order.push(key);
        }
        groups[key].push(line);
      });
      return order.map(function (key) { return aggregateLines(groups[key]); }).filter(Boolean);
    }

    function findLine(variantId) {
      return groupedLines().find(function (line) { return String(line.variantId) === String(variantId); }) || null;
    }
    // Agent END: split-line-safe builder grouping.

    // Agent START: inline phone-model switch helpers with one explicit link-style action.
    function findLineByKey(cartKey) {
      return state.lines.find(function (line) { return String(line.cartKey) === String(cartKey); }) || null;
    }

    function productForLine(line) {
      if (!line) return null;
      return products.find(function (product) {
        return String(product.id) === String(line.productId) || product.handle === line.handle;
      }) || null;
    }

    function deviceSwitchMarkup(device, lineKey, design, productId) {
      var context = lineKey ? ' for ' + design + ' in your cart' : '';
      return '<button type="button" class="scooch-pick4__device-switch" data-pick4-device-switch' +
        (lineKey ? ' data-pick4-line-key="' + escapeHtml(lineKey) + '"' : '') +
        (productId ? ' data-pick4-product-id="' + escapeHtml(productId) + '"' : '') +
        (design ? ' data-pick4-design="' + escapeHtml(design) + '"' : '') +
        ' aria-label="Switch device' + escapeHtml(context) + '">' +
          '<span class="scooch-pick4__device-switch-model">' + escapeHtml(device) + '</span>' +
          '<span class="scooch-pick4__device-switch-action">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h13m0 0-3-3m3 3-3 3M19 16H6m0 0 3-3m-3 3 3 3"></path></svg>' +
            '<span>Switch device</span>' +
          '</span>' +
      '</button>';
    }
    // Agent END: inline phone-model switch helpers.

    // Agent START: assign discount display to exact Shopify cart lines, including split lines for the same variant.
    function linePreviewKey(line) {
      return String(line.cartKey || (String(line.variantId) + ':' + String(line.addedAt || '0')));
    }

    function pricePreview() {
      var total = 0;
      var due = 0;
      var savingsTotal = 0;
      var freeCounts = Object.create(null);
      state.lines.forEach(function (line) {
        var quantity = Math.max(0, Number(line.quantity) || 0);
        var originalLinePrice = Number(line.originalLinePrice);
        var finalLinePrice = Number(line.finalLinePrice);
        if (!Number.isFinite(originalLinePrice)) originalLinePrice = line.price * quantity;
        if (!Number.isFinite(finalLinePrice)) finalLinePrice = originalLinePrice;
        total += originalLinePrice;
        due += finalLinePrice;
        var lineSavings = Math.max(0, originalLinePrice - finalLinePrice);
        savingsTotal += lineSavings;
        if (lineSavings > 0 && line.price > 0) {
          freeCounts[linePreviewKey(line)] = Math.min(quantity, Math.round(lineSavings / line.price));
        }
      });
      var signature = Object.keys(freeCounts).sort().map(function (key) { return key + ':' + freeCounts[key]; }).join('|');
      var totalUnits = state.lines.reduce(function (sum, line) { return sum + Math.max(0, Number(line.quantity) || 0); }, 0);
      return { totalUnits: totalUnits, subtotal: total, savings: savingsTotal, due: due, freeCounts: freeCounts, signature: signature };
    }
    // Agent END: exact cart-line discount allocation.

    function badgeMarkup(item) {
      var badges = [];
      if (item.isNew) badges.push('<span class="scooch-badge scooch-badge--new scooch-badge--surface-card" data-scooch-badge data-scooch-badge-kind="new" data-scooch-badge-surface="card">New</span>');
      if (item.isSale) badges.push('<span class="scooch-badge scooch-badge--sale scooch-badge--surface-card" data-scooch-badge data-scooch-badge-kind="sale" data-scooch-badge-surface="card">Sale</span>');
      if (item.isLimited) badges.push('<span class="scooch-badge scooch-badge--limited scooch-badge--surface-card" data-scooch-badge data-scooch-badge-kind="limited" data-scooch-badge-surface="card">Limited</span>');
      return badges.length ? '<span class="scooch-pick4__badge-stack">' + badges.join('') + '</span>' : '';
    }

    var quantityIcons = {
      plus: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
      minus: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
      trash: '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M6 7l1 14h10l1-14"/><path d="M9 7V4h6v3"/></svg>'
    };

    // Agent START: checkout-style selected color while the design card keeps a simple quantity control.
    function quantityControlMarkup(line, variantId, label, highlightSelectedState) {
      var disabled = state.cartBusy || !cartEnabled ? ' disabled aria-disabled="true"' : '';
      if (!line) {
        var pending = state.cartBusy && String(state.pendingVariantId) === String(variantId);
        return '<button type="button" class="scooch-pick4__add' + (pending ? ' is-loading' : '') + '" data-pick4-add="' + escapeHtml(variantId) + '"' + (pending ? ' aria-busy="true"' : '') + disabled + '>' +
          (pending ? '<span class="scooch-pick4__spinner" aria-hidden="true"></span><span>Adding</span>' : 'Add') +
        '</button>';
      }
      var quantity = line.quantity;
      var selectedClass = highlightSelectedState ? ' scooch-pick4__qty--selected' : '';
      return '<div class="scooch-pick4__qty' + selectedClass + '" role="group" aria-label="Quantity for ' + escapeHtml(label) + ', ' + quantity + '">' +
        '<button type="button" data-pick4-quantity="down" data-variant-id="' + escapeHtml(variantId) + '" aria-label="' + (quantity > 1 ? 'Decrease quantity' : 'Remove item') + '"' + disabled + '>' + (quantity > 1 ? quantityIcons.minus : quantityIcons.trash) + '</button>' +
        '<span aria-live="polite">' + quantity + '</span>' +
        '<button type="button" data-pick4-quantity="up" data-variant-id="' + escapeHtml(variantId) + '" aria-label="Increase quantity"' + disabled + '>' + quantityIcons.plus + '</button>' +
      '</div>';
    }
    // Agent END: simplified selected design quantity state.

    // Agent START: keep design cards at their unit price; free-item truth is shown only in the cart preview.
    function cardMarkup(item, preview) {
      var line = findLine(item.variant.id);
      var image = previewImage(item.product, item.variant);
      var priceMarkup = money(item.variant.price);
      return '<article class="scooch-pick4__design-card' + (line ? ' has-quantity' : '') + '" data-pick4-card-variant="' + escapeHtml(item.variant.id) + '">' +
        '<div class="scooch-pick4__design-image">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product.family + ' ' + item.product.design + ' case for ' + item.variant.device) + '" width="720" height="720" loading="lazy">' : '') +
          badgeMarkup(item) +
          (image ? '<button type="button" class="scooch-pick4__zoom-trigger" data-pick4-zoom aria-label="Zoom ' + escapeHtml(item.product.design) + ' case image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m15.5 15.5 4.5 4.5M10.5 7.5v6M7.5 10.5h6"></path></svg></button>' : '') +
        '</div>' +
        '<div class="scooch-pick4__design-body">' +
          '<span class="scooch-pick4__design-family">' + escapeHtml(item.product.family) + '</span>' +
          '<strong class="scooch-pick4__design-name">' + escapeHtml(item.product.design) + '</strong>' +
          deviceSwitchMarkup(item.variant.device, '', item.product.design, item.product.id) +
          '<span class="scooch-pick4__design-price">' + priceMarkup + '</span>' +
          quantityControlMarkup(line, item.variant.id, item.product.design, true) +
        '</div>' +
      '</article>';
    }
    // Agent END: design-card price isolation.

    function representativeProduct(family) {
      var candidates = products.filter(function (product) { return product.family === family && product.image; });
      if (state.device) {
        var deviceMatch = candidates.find(function (product) { return !!getVariant(product, state.device); });
        if (deviceMatch) return deviceMatch;
      }
      return candidates[0] || null;
    }

    function renderFamilyTiles() {
      var availableFamilies = availableFamiliesForDevice(state.device);
      familyTiles.dataset.pick4FamilyCount = String(availableFamilies.length);
      familyTiles.innerHTML = availableFamilies.map(function (family) {
        var product = representativeProduct(family);
        var variant = product && state.device ? getVariant(product, state.device) : null;
        var image = previewImage(product, variant);
        var selected = state.family === family;
        return '<button type="button" class="scooch-pick4__family-tile" data-filter-family="' + family + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
          '<span class="scooch-pick4__family-image">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" width="480" height="480">' : '') + '</span>' +
          '<strong>' + family + '</strong>' +
          '<span class="scooch-pick4__family-status" aria-hidden="true">' + (selected ? '✓ Selected' : 'Select') + '</span>' +
          (selected ? '<span class="scooch-pick4__visually-hidden">Selected</span>' : '') +
        '</button>';
      }).join('');
    }

    function designDescriptor(count) {
      var noun = count === 1 ? 'design' : 'designs';
      if (state.style === 'sale') return state.family + ' ' + noun + ' on sale';
      if (state.style === 'limited') return 'limited-edition ' + state.family + ' ' + noun;
      if (state.style === 'menspicks') return state.family + ' ' + noun + ' in Men’s Picks';
      if (state.style === 'womenspicks') return state.family + ' ' + noun + ' in Women’s Picks';
      if (state.style === 'floral') return 'floral ' + state.family + ' ' + noun;
      if (state.style === 'animal') return 'animal ' + state.family + ' ' + noun;
      return state.family + ' ' + noun;
    }

    function renderDrawerCatalog() {
      if (!drawer || !drawer.open) return;
      var designs = availableDesigns();
      var preview = pricePreview();
      drawerGrid.innerHTML = state.family ? designs.map(function (item) { return cardMarkup(item, preview); }).join('') : '';
      drawerCount.textContent = state.device && state.family
        ? designs.length + ' ' + designDescriptor(designs.length) + ' for ' + state.device
        : 'Choose your phone model first';
      var message = state.family && state.device && !designs.length
        ? 'No ' + state.family + ' designs match this phone and filter. Try another phone model, case type, style, or search.'
        : '';
      drawerEmpty.textContent = message;
      drawerEmpty.hidden = !message;
    }

    function renderCatalog() {
      var preview = pricePreview();
      var designs = availableDesigns();
      var mainDesigns = designs.slice(0, state.visibleLimit);
      // Agent START: one visible decision at a time — phone, then case type, then designs.
      familyPicker.hidden = !state.device;
      resultsBar.hidden = !state.device;
      postFamily.hidden = !state.device || !state.family;
      grid.innerHTML = state.family ? mainDesigns.map(function (item) { return cardMarkup(item, preview); }).join('') : '';
      if (!state.device) resultsLabel.textContent = '';
      else if (!state.family) resultsLabel.textContent = 'Choose a case type to see designs.';
      else resultsLabel.textContent = designs.length + ' ' + designDescriptor(designs.length) + ' for ' + state.device;
      // Agent END: progressive phone-to-design reveal.

      var hasMore = designs.length > mainDesigns.length;
      openDrawer.disabled = !hasMore;
      openDrawer.hidden = !hasMore;
      openDrawer.textContent = hasMore ? 'View all ' + designs.length : 'View all designs';
      pagination.hidden = !hasMore;
      pageStatus.textContent = hasMore ? 'Showing ' + mainDesigns.length + ' of ' + designs.length : '';
      loadMore.textContent = hasMore ? 'Show ' + Math.min(12, designs.length - mainDesigns.length) + ' more' : 'Show more';

      var message = '';
      if (state.family && state.device && !designs.length) message = 'No ' + state.family + ' designs match this phone and filter. Try another phone model, case type, style, or search.';
      empty.textContent = message;
      empty.hidden = !message || mainDesigns.length > 0;
      root.querySelectorAll('[data-filter-family]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.filterFamily === state.family ? 'true' : 'false');
      });
      root.querySelectorAll('[data-filter-style]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.dataset.filterStyle === state.style ? 'true' : 'false');
      });
      searchInputs.forEach(function (input) { if (input.value !== state.query) input.value = state.query; });
      renderDrawerCatalog();
    }

    function selectionForVariant(variantId) {
      var product = products.find(function (candidate) {
        return candidate.variants.some(function (variant) { return String(variant.id) === String(variantId); });
      });
      if (!product) return null;
      var variant = product.variants.find(function (candidate) { return String(candidate.id) === String(variantId) && candidate.available !== false; });
      if (!variant) return null;
      return {
        productId: product.id, handle: product.handle, family: product.family, design: product.design,
        image: previewImage(product, variant), variantId: variant.id, device: variant.device, price: Number(variant.price) || 0
      };
    }

    function showFreeUpdate(before, after) {
      if (!before || !after || before === after || !freeUpdate) return;
      window.clearTimeout(freeUpdateTimer);
      freeUpdate.hidden = false;
      freeUpdateTimer = window.setTimeout(function () { freeUpdate.hidden = true; }, 5000);
    }

    function linePriceMarkup(line, preview) {
      var rawLines = line.rawLines || [line];
      var freeQuantity = rawLines.reduce(function (sum, rawLine) {
        return sum + (preview.freeCounts[linePreviewKey(rawLine)] || 0);
      }, 0);
      var paidQuantity = line.quantity - freeQuantity;
      if (!freeQuantity) return '<strong>' + money(line.finalLinePrice) + '</strong>';
      if (!paidQuantity) return '<span><s>' + money(line.originalLinePrice) + '</s><strong>FREE</strong></span>';
      return '<span><small><s>' + freeQuantity + ' × ' + money(line.price) + '</s> FREE</small><strong>' + money(line.finalLinePrice) + '</strong></span>';
    }

    function renderTray() {
      var preview = pricePreview();
      var displayLines = groupedLines();
      if (!displayLines.length) selectedLines.innerHTML = '<p class="scooch-pick4__tray-empty">Your deal cases will appear here.</p>';
      else {
        selectedLines.innerHTML = displayLines.map(function (line) {
          return '<article class="scooch-pick4__selected-line">' +
            (line.image ? '<img src="' + escapeHtml(line.image) + '" alt="" width="104" height="120">' : '') +
            '<div class="scooch-pick4__line-copy"><strong>' + escapeHtml(line.design) + '</strong><div class="scooch-pick4__line-meta"><span>' + escapeHtml(line.family) + ' ·</span>' + deviceSwitchMarkup(line.device, line.cartKey, line.design, line.productId) + '</div>' + quantityControlMarkup(line, line.variantId, line.design, false) + '</div>' +
            '<div class="scooch-pick4__line-price">' + linePriceMarkup(line, preview) + '</div>' +
          '</article>';
        }).join('');
      }

      var unitWord = preview.totalUnits === 1 ? 'case' : 'cases';
      // Agent START: replace passive zero/progress labels with clear Add actions.
      var cartUnitWord = state.cartItemCount === 1 ? 'item' : 'items';
      cartCount.textContent = state.cartItemCount + ' ' + cartUnitWord;
      count.textContent = preview.totalUnits <= dealQuantity ? preview.totalUnits + ' of ' + dealQuantity : preview.totalUnits + ' cases';
      var mobilePreviewLines = [];
      state.lines.forEach(function (line) {
        for (var mobileUnit = 0; mobileUnit < line.quantity && mobilePreviewLines.length < dealQuantity; mobileUnit += 1) {
          mobilePreviewLines.push(line);
        }
      });
      mobilePreviews.hidden = mobilePreviewLines.length === 0;
      mobilePreviews.innerHTML = mobilePreviewLines.map(function (line) {
        return '<img src="' + escapeHtml(line.image) + '" alt="" width="64" height="76">';
      }).join('') + (preview.totalUnits > dealQuantity ? '<span>+' + (preview.totalUnits - dealQuantity) + '</span>' : '');
      if (!state.device) {
        mobileBar.dataset.pick4MobileStep = 'phone';
        mobileStepTrack.style.width = '33.333%';
        mobilePreviews.hidden = true;
        mobileCount.textContent = 'Select phone model';
        mobileProgress.textContent = 'Step 1 of 3';
        reviewButton.disabled = false;
        reviewButton.textContent = 'Choose phone';
      } else if (!state.family) {
        mobileBar.dataset.pick4MobileStep = 'family';
        mobileStepTrack.style.width = '66.666%';
        mobilePreviews.hidden = true;
        mobileCount.textContent = 'Select case type';
        mobileProgress.textContent = state.device + ' selected';
        reviewButton.disabled = false;
        reviewButton.textContent = 'Choose type';
      } else {
        mobileBar.dataset.pick4MobileStep = 'designs';
        mobileStepTrack.style.width = '100%';
        mobilePreviews.hidden = mobilePreviewLines.length === 0;
        mobileCount.textContent = preview.totalUnits ? preview.totalUnits + ' ' + unitWord : 'Add a case';
        reviewButton.disabled = state.cartBusy;
        reviewButton.textContent = state.cartBusy ? 'Updating…' : 'View cart';
      }
      progressBar.style.width = Math.min(100, (preview.totalUnits / dealQuantity) * 100) + '%';
      if (preview.totalUnits < dealQuantity) {
        var remaining = dealQuantity - preview.totalUnits;
        progress.textContent = 'Add ' + remaining + ' more to unlock savings.';
        if (state.device && state.family) mobileProgress.textContent = 'Add ' + remaining + ' more to unlock savings';
      } else {
        progress.textContent = 'Deal unlocked.';
        if (state.device && state.family) mobileProgress.textContent = 'You save ' + money(preview.savings);
      }
      // Agent END: actionable empty count and savings progress copy.
      // Agent START: show non-PICK4 cart contents as ordinary context, not a warning.
      var visibleOtherLines = state.otherLines.slice(0, 3);
      var hiddenOtherUnits = state.otherLines.slice(3).reduce(function (sum, line) { return sum + line.quantity; }, 0);
      otherGroup.hidden = state.otherLines.length === 0;
      otherLines.innerHTML = visibleOtherLines.map(function (line) {
        var meta = 'Qty ' + line.quantity + (line.variantTitle ? ' · ' + escapeHtml(line.variantTitle) : '');
        return '<article class="scooch-pick4__other-line">' +
          (line.image ? '<img src="' + escapeHtml(line.image) + '" alt="" width="88" height="88">' : '') +
          '<div><strong>' + escapeHtml(line.title) + '</strong><small>' + meta + '</small>' + (line.conflicts ? '<em>Not part of this deal</em>' : '') + '</div>' +
          '<span>' + money(line.finalLinePrice) + '</span>' +
        '</article>';
      }).join('');
      otherOverflow.hidden = hiddenOtherUnits === 0;
      otherOverflow.textContent = hiddenOtherUnits ? '+' + hiddenOtherUnits + ' more in cart' : '';
      var otherUnits = state.otherLines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
      var otherSubtotal = state.otherLines.reduce(function (sum, line) { return sum + line.finalLinePrice; }, 0);
      totals.hidden = preview.totalUnits === 0 && otherUnits === 0;
      subtotalLabel.textContent = 'Deal ' + unitWord + ' (' + preview.totalUnits + ')';
      subtotal.textContent = money(preview.subtotal);
      savings.textContent = preview.savings ? '-' + money(preview.savings) : money(0);
      otherTotalRow.hidden = otherUnits === 0;
      otherTotalLabel.textContent = 'Other items (' + otherUnits + ')';
      otherTotal.textContent = money(otherSubtotal);
      pay.textContent = money(state.cartTotal);
      cartButton.disabled = !cartEnabled || state.cartBusy || state.cartItemCount === 0;
      if (state.cartBusy) cartButton.textContent = 'Updating cart…';
      else if (preview.totalUnits === 0 && state.cartItemCount === 0) cartButton.textContent = 'Add ' + dealQuantity + ' cases to start';
      else if (preview.totalUnits === 0) cartButton.textContent = 'View cart (' + state.cartItemCount + ' ' + cartUnitWord + ')';
      else if (preview.totalUnits < dealQuantity) cartButton.textContent = 'View cart — add ' + (dealQuantity - preview.totalUnits) + ' more';
      else cartButton.textContent = 'Review cart';
      // Agent END: full-cart context and totals.
    }

    function renderAll() {
      deviceTrigger.classList.toggle('needs-selection', !state.device);
      // Agent START: keep the selected phone check informative without blocking the reusable trigger.
      if (deviceSelectionCheck) deviceSelectionCheck.hidden = !state.device;
      deviceTrigger.setAttribute('aria-label', state.device ? 'Selected phone model: ' + state.device + '. Change phone model.' : 'Choose your phone model');
      // Agent END: accessible selected phone confirmation.
      renderFamilyTiles();
      renderCatalog();
      renderTray();
      // Agent: re-apply a deferred hide if a cart render removed focus from the mobile guide.
      applyBuilderActive();
    }

    function populateDevices() {
      var seen = Object.create(null);
      var devices = [];
      products.forEach(function (product) {
        product.variants.forEach(function (variant) {
          if (!variant || !variant.available || seen[variant.device]) return;
          seen[variant.device] = true;
          devices.push(variant.device);
        });
      });
      devices.forEach(function (device) {
        var option = document.createElement('option');
        option.value = device;
        option.textContent = device;
        deviceSelect.appendChild(option);
      });
      if (state.device && seen[state.device]) deviceSelect.value = state.device;
      else state.device = '';
      renderDeviceOptions();
    }

    function renderDeviceOptions() {
      if (!deviceOptions || !deviceTrigger) return;
      var targetLine = findLineByKey(deviceChangeTargetKey);
      // Agent START: scope design-card phone choices to that product's real variants.
      var targetProduct = productForLine(targetLine) || products.find(function (product) {
        return String(product.id) === String(deviceChangeTargetProductId);
      }) || null;
      var selectedDevice = targetLine ? targetLine.device : state.device;
      var allowedDevices = null;
      if (targetProduct) {
        allowedDevices = targetProduct.variants.reduce(function (lookup, variant) {
          if (variant && variant.available !== false) lookup[variant.device] = true;
          return lookup;
        }, Object.create(null));
      }
      var groups = [
        { label: 'Apple iPhone', values: [] },
        { label: 'Samsung Galaxy', values: [] }
      ];
      Array.prototype.slice.call(deviceSelect.options).forEach(function (option) {
        if (!option.value || option.disabled || option.hidden || (allowedDevices && !allowedDevices[option.value])) return;
        groups[option.value.indexOf('Galaxy') === 0 ? 1 : 0].values.push(option.value);
      });
      deviceOptions.innerHTML = groups.map(function (group) {
        if (!group.values.length) return '';
        return '<div class="scooch-pick4__device-group"><h3>' + group.label + '</h3>' + group.values.map(function (value) {
          var selected = value === selectedDevice;
          return '<button type="button" class="scooch-pick4__device-option' + (selected ? ' is-selected' : '') + '" data-pick4-device-option="' + escapeHtml(value) + '"' + (selected ? ' aria-current="true"' : '') + '>' +
            '<span>' + escapeHtml(value) + '</span><span class="scooch-pick4__device-check" aria-hidden="true">✓</span>' +
          '</button>';
        }).join('') + '</div>';
      }).join('');
      if (deviceDialogTitle) {
        var targetDesign = targetLine ? targetLine.design : deviceChangeTargetDesign;
        deviceDialogTitle.textContent = targetProduct && targetDesign ? 'Switch ' + targetDesign + ' phone' : 'Choose your phone model';
      }
      // Agent END: scope design-card phone choices to that product's real variants.
      deviceValue.textContent = state.device || 'Choose your phone model';
      deviceTrigger.classList.toggle('has-value', !!state.device);
    }

    function openDevicePicker(opener, lineKey, productId, design) {
      deviceChangeTargetKey = lineKey || '';
      deviceChangeTargetProductId = productId || '';
      deviceChangeTargetDesign = design || '';
      deviceReturnFocus = opener || deviceTrigger;
      renderDeviceOptions();
      deviceTrigger.setAttribute('aria-expanded', 'true');
      deviceDialog.showModal();
    }

    function closeDevicePicker() {
      if (deviceDialog.open) deviceDialog.close();
    }

    function restoreState() {
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        if (!saved) return;
        if (typeof saved.device === 'string') state.device = saved.device;
        if (families.indexOf(saved.family) !== -1) state.family = saved.family;
        if (typeof saved.style === 'string') state.style = saved.style;
        if (typeof saved.query === 'string') state.query = saved.query;
      } catch (error) {}
    }

    function renderHero() {
      // Agent: preserve server-rendered transparent hero cutouts; product-data images remain the fallback.
      if (!heroCases || heroCases.children.length) return;
      var preferredDesigns = ['wildflowers', 'sunflower frenzy', 'baby cow', 'checkered beige'];
      var seenDesigns = Object.create(null);
      var seenImages = Object.create(null);
      var featured = products.filter(function (product) {
        if (product.family !== 'Wingmate' || !product.image) return false;
        var designKey = String(product.design || product.handle || '').toLowerCase();
        if (seenDesigns[designKey] || seenImages[product.image]) return false;
        seenDesigns[designKey] = true;
        seenImages[product.image] = true;
        return true;
      }).sort(function (a, b) {
        var aIndex = preferredDesigns.indexOf(String(a.design || '').toLowerCase());
        var bIndex = preferredDesigns.indexOf(String(b.design || '').toLowerCase());
        if (aIndex === -1) aIndex = preferredDesigns.length;
        if (bIndex === -1) bIndex = preferredDesigns.length;
        return aIndex - bIndex;
      }).slice(0, dealQuantity);
      heroCases.innerHTML = featured.map(function (product) {
        return '<span class="scooch-pick4__hero-case"><img src="' + escapeHtml(product.image) + '" alt="" width="720" height="720"></span>';
      }).join('');
    }

    function routeUrl(path) {
      var base = rootUrl.charAt(rootUrl.length - 1) === '/' ? rootUrl : rootUrl + '/';
      return base + String(path || '').replace(/^\//, '');
    }

    function cartRequest(path, payload) {
      return fetch(routeUrl(path), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload || {})
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'We could not update your cart. Please try again.');
          return body;
        });
      });
    }

    function fetchCart() {
      return fetch(routeUrl('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('We could not load your cart. Please refresh and try again.');
        return response.json();
      });
    }

    function isOwnedCartItem(item) {
      return !!(item && item.properties && String(item.properties[ownerProperty] || '').toUpperCase() === ownerValue);
    }

    function ownedUnits(cart) {
      return (cart && Array.isArray(cart.items) ? cart.items : []).reduce(function (sum, item) {
        return sum + (isOwnedCartItem(item) ? Math.max(0, Number(item.quantity) || 0) : 0);
      }, 0);
    }

    function hasForeignCase(cart) {
      return (cart && Array.isArray(cart.items) ? cart.items : []).some(function (item) {
        return eligibleProductIds[String(item.product_id)] && !isOwnedCartItem(item);
      });
    }

    function cartCodes(cart, excludePick4) {
      var seen = Object.create(null);
      return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).map(function (entry) {
        return entry && entry.code ? String(entry.code).trim() : '';
      }).filter(function (code) {
        var normalized = code.toLowerCase();
        if (!code || seen[normalized] || (excludePick4 && normalized === discountCode.toLowerCase())) return false;
        seen[normalized] = true;
        return true;
      });
    }

    function sameCodes(left, right) {
      var normalize = function (codes) { return codes.map(function (code) { return code.toLowerCase(); }).sort().join('|'); };
      return normalize(left) === normalize(right);
    }

    function hydrateFromCart(cart) {
      var before = pricePreview().signature;
      state.lines = (cart && Array.isArray(cart.items) ? cart.items : []).map(function (item, index) {
        if (!isOwnedCartItem(item)) return null;
        var selection = selectionForVariant(item.variant_id) || {
          productId: item.product_id,
          handle: item.handle || '',
          family: item.properties._scooch_pick4_family || 'Case',
          design: item.properties._scooch_pick4_design || item.product_title || 'Case',
          image: item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || ''),
          variantId: item.variant_id,
          device: item.properties._scooch_pick4_device || (item.variant_options && item.variant_options[0]) || item.variant_title || '',
          price: Number(item.original_price || item.price) || 0
        };
        selection.quantity = Math.max(1, Number(item.quantity) || 1);
        selection.cartKey = item.key;
        selection.price = Number(item.original_price || item.price) || selection.price;
        selection.originalLinePrice = Number(item.original_line_price);
        selection.finalLinePrice = Number(item.final_line_price);
        selection.addedAt = index + 1;
        return selection;
      }).filter(Boolean);
      // Agent START: on first load, resume the dominant device and case type already in the deal cart.
      if (!initialCartSelectionApplied) {
        initialCartSelectionApplied = true;
        var selectionGroups = state.lines.reduce(function (groups, line, index) {
          if (!line.device || families.indexOf(line.family) === -1) return groups;
          var key = line.device + '\u0000' + line.family;
          if (!groups[key]) {
            groups[key] = {
              device: line.device,
              family: line.family,
              quantity: 0,
              firstIndex: index
            };
          }
          groups[key].quantity += Math.max(1, Number(line.quantity) || 1);
          return groups;
        }, Object.create(null));
        var resumableGroups = Object.keys(selectionGroups).map(function (key) {
          return selectionGroups[key];
        }).filter(function (group) {
          if (state.device && group.device !== state.device) return false;
          return availableFamiliesForDevice(group.device).indexOf(group.family) !== -1;
        }).sort(function (left, right) {
          return right.quantity - left.quantity || left.firstIndex - right.firstIndex;
        });
        var resumeSelection = resumableGroups[0] || null;
        var restoredSelection = false;
        if (resumeSelection && !state.device) {
          state.device = resumeSelection.device;
          restoredSelection = true;
        }
        if (resumeSelection && !state.family) {
          state.family = resumeSelection.family;
          restoredSelection = true;
        }
        if (restoredSelection) {
          deviceSelect.value = state.device;
          saveState();
          renderDeviceOptions();
        }
      }
      // Agent END: resume initial builder controls from existing deal-cart lines.
      // Agent START: retain compact read-only context for every non-PICK4 cart line.
      state.otherLines = (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
        return !isOwnedCartItem(item);
      }).map(function (item) {
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var finalLinePrice = Number(item.final_line_price);
        if (!Number.isFinite(finalLinePrice)) finalLinePrice = Number(item.original_line_price) || 0;
        return {
          title: item.product_title || item.title || 'Cart item',
          variantTitle: variantTitle,
          image: item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || ''),
          quantity: Math.max(1, Number(item.quantity) || 1),
          finalLinePrice: finalLinePrice,
          conflicts: !!eligibleProductIds[String(item.product_id)]
        };
      });
      state.cartItemCount = Math.max(0, Number(cart && cart.item_count) || 0);
      state.cartTotal = Math.max(0, Number(cart && cart.total_price) || 0);
      // Agent END: full-cart read-only context.
      state.foreignCaseConflict = hasForeignCase(cart);
      state.discountApplicable = (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).some(function (entry) {
        return entry && entry.code && entry.code.toLowerCase() === discountCode.toLowerCase() && entry.applicable === true;
      });
      showFreeUpdate(before, pricePreview().signature);
    }

    function desiredDiscountCodes(cart) {
      var codes = cartCodes(cart, true);
      if (ownedUnits(cart) >= dealQuantity && !hasForeignCase(cart)) codes.push(discountCode);
      return codes;
    }

    function reconcileDiscount(cart, sections) {
      var currentCodes = cartCodes(cart, false);
      var desiredCodes = desiredDiscountCodes(cart);
      if (sameCodes(currentCodes, desiredCodes)) {
        if (sections) cart.sections = sections;
        return Promise.resolve(cart);
      }
      return cartRequest('cart/update.js', { discount: desiredCodes.join(','), sections: ['mini-cart'] });
    }

    function setCartError(message) {
      errorBox.textContent = message || '';
      errorBox.hidden = !message;
    }

    function showCartStatus() {
      var totalUnits = pricePreview().totalUnits;
      if (state.foreignCaseConflict) {
        setCartError('Another case or case bundle is already in your cart. Remove it before using this deal; accessories and screen protectors can stay.');
      } else if (totalUnits >= dealQuantity && !state.discountApplicable) {
        setCartError('The buy 2, get 1 free discount could not be applied. It cannot be combined with another discount. Review your cart and try again.');
      } else setCartError('');
    }

    function publishCart(cart, openMiniCart) {
      dispatchingCartEvent = true;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: !!openMiniCart }
      }));
      dispatchingCartEvent = false;
    }

    function finishCartUpdate(cart, openMiniCart) {
      hydrateFromCart(cart);
      state.cartBusy = false;
      state.pendingVariantId = '';
      renderAll();
      showCartStatus();
      publishCart(cart, openMiniCart);
      return cart;
    }

    function refreshCart(syncDiscount, publish) {
      return fetchCart().then(function (cart) {
        return syncDiscount && cartEnabled ? reconcileDiscount(cart, cart.sections) : cart;
      }).then(function (cart) {
        hydrateFromCart(cart);
        state.cartBusy = false;
        state.pendingVariantId = '';
        renderAll();
        showCartStatus();
        if (publish && cart.sections) publishCart(cart, false);
        return cart;
      });
    }

    // Agent START: add and remove one aggregate builder unit at a time so Shopify split lines cannot inflate or hide quantity.
    function cartProperties(selection, device) {
      return {
        _scooch_pick4: ownerValue,
        _scooch_pick4_family: selection.family,
        _scooch_pick4_device: device || selection.device,
        _scooch_pick4_design: selection.design
      };
    }

    function decrementTarget(line) {
      var candidates = rawLinesForGroup(line).slice().sort(function (left, right) {
        var leftPaid = Number(left.finalLinePrice) > 0 ? 1 : 0;
        var rightPaid = Number(right.finalLinePrice) > 0 ? 1 : 0;
        return rightPaid - leftPaid || right.quantity - left.quantity;
      });
      return candidates[0] || null;
    }

    function cartGroupItems(cart, line) {
      var groupKey = lineGroupKey(line);
      return (cart && Array.isArray(cart.items) ? cart.items : []).filter(function (item) {
        return isOwnedCartItem(item) && cartItemGroupKey(item) === groupKey;
      });
    }

    function cartGroupQuantity(cart, line) {
      return cartGroupItems(cart, line).reduce(function (sum, item) {
        return sum + Math.max(0, Number(item.quantity) || 0);
      }, 0);
    }

    function ensureCartGroupQuantity(cart, line, targetQuantity) {
      var currentQuantity = cartGroupQuantity(cart, line);
      if (currentQuantity === targetQuantity) return Promise.resolve(cart);
      var correction;
      if (currentQuantity < targetQuantity) {
        correction = cartRequest('cart/add.js', {
          items: [{
            id: Number(line.variantId),
            quantity: targetQuantity - currentQuantity,
            properties: cartProperties(line)
          }],
          sections: ['mini-cart']
        }).then(function () { return fetchCart(); });
      } else {
        var excess = currentQuantity - targetQuantity;
        var targetItem = cartGroupItems(cart, line).slice().sort(function (left, right) {
          var leftPaid = Number(left.final_line_price) > 0 ? 1 : 0;
          var rightPaid = Number(right.final_line_price) > 0 ? 1 : 0;
          return rightPaid - leftPaid || right.quantity - left.quantity;
        })[0];
        if (!targetItem) return Promise.reject(new Error('We could not verify this case quantity.'));
        correction = cartRequest('cart/change.js', {
          id: targetItem.key,
          quantity: Math.max(0, targetItem.quantity - Math.min(excess, targetItem.quantity)),
          sections: ['mini-cart']
        });
      }
      return correction.then(function (correctedCart) {
        return reconcileDiscount(correctedCart, correctedCart.sections);
      }).then(function (correctedCart) {
        if (cartGroupQuantity(correctedCart, line) !== targetQuantity) {
          throw new Error('Your cart changed while we were updating it. Please try again.');
        }
        return correctedCart;
      });
    }

    function changeQuantity(variantId, delta) {
      if (!cartEnabled || state.cartBusy) return Promise.resolve(null);
      var line = findLine(variantId);
      var selection = line || selectionForVariant(variantId);
      var direction = Number(delta) > 0 ? 1 : -1;
      if (!selection || (!line && direction < 0)) return Promise.resolve(null);
      var nextQuantity = Math.max(0, (line ? line.quantity : 0) + direction);
      var targetLine = direction < 0 ? decrementTarget(line) : null;
      if (direction < 0 && !targetLine) return Promise.resolve(null);
      state.cartBusy = true;
      state.pendingVariantId = !line && direction > 0 ? String(variantId) : '';
      setCartError('');
      renderAll();

      var request;
      if (direction < 0) {
        request = cartRequest('cart/change.js', {
          id: targetLine.cartKey,
          quantity: Math.max(0, targetLine.quantity - 1),
          sections: ['mini-cart']
        });
      } else {
        request = cartRequest('cart/add.js', {
          items: [{
            id: Number(selection.variantId),
            quantity: 1,
            properties: cartProperties(selection)
          }],
          sections: ['mini-cart']
        });
      }

      return request.then(function (mutationResult) {
        if (direction < 0) return reconcileDiscount(mutationResult, mutationResult.sections);
        // Agent: cart/add.js returns added items rather than canonical split-line cart state.
        return fetchCart().then(function (cart) {
          return reconcileDiscount(cart, mutationResult.sections);
        });
      }).then(function (cart) {
        return direction < 0 ? ensureCartGroupQuantity(cart, selection, nextQuantity) : cart;
      }).then(function (cart) {
        return finishCartUpdate(cart, false);
      }).then(function (cart) {
        announce(selection.design + (nextQuantity > 0 ? ' updated in your cart.' : ' removed from your cart.'));
        // Agent START: the Add button is replaced after success, so return keyboard focus to its matching plus control.
        if (!line && direction > 0) {
          var focusScope = drawer && drawer.open ? drawerGrid : grid;
          var addedCard = focusScope && Array.prototype.slice.call(focusScope.querySelectorAll('[data-pick4-card-variant]')).find(function (card) {
            return String(card.dataset.pick4CardVariant) === String(variantId);
          });
          var addedPlus = addedCard && addedCard.querySelector('[data-pick4-quantity="up"]');
          if (addedPlus) addedPlus.focus({ preventScroll: true });
        }
        // Agent END: post-add focus restoration.
        return cart;
      }).catch(function (error) {
        state.cartBusy = false;
        state.pendingVariantId = '';
        refreshCart(false, false).catch(function () {}).then(function () {
          renderAll();
          setCartError(error.message || 'We could not update your cart. Please try again.');
        });
      });
    }
    // Agent END: split-line-safe aggregate quantity mutations.

    // Agent START: replace every split line in one selected case group with the same design for another phone model.
    function cartItemMatchesGroup(item, line) {
      return isOwnedCartItem(item) && cartItemGroupKey(item) === lineGroupKey(line);
    }

    function removeGroupSequentially(line, remaining) {
      var attempts = Math.max(1, Number(remaining) || 1);
      return fetchCart().then(function removeNext(cart) {
        var currentLine = (cart.items || []).find(function (item) { return cartItemMatchesGroup(item, line); });
        if (!currentLine) return cart;
        if (attempts <= 0) throw new Error('We could not remove the original phone size from your cart.');
        attempts -= 1;
        return cartRequest('cart/change.js', { id: currentLine.key, quantity: 0, sections: ['mini-cart'] })
          .then(function () { return fetchCart(); })
          .then(removeNext);
      });
    }

    function switchLineDevice(line, nextDevice) {
      if (!cartEnabled || state.cartBusy || !line) return Promise.resolve(null);
      line = aggregateLines(rawLinesForGroup(line)) || line;
      var product = productForLine(line);
      var nextVariant = product ? getVariant(product, nextDevice) : null;
      if (!nextVariant) {
        setCartError('This design is not available for ' + nextDevice + '.');
        return Promise.resolve(null);
      }
      if (String(nextVariant.id) === String(line.variantId)) {
        state.device = nextDevice;
        deviceSelect.value = nextDevice;
        saveState();
        renderDeviceOptions();
        renderAll();
        return Promise.resolve(null);
      }

      state.cartBusy = true;
      state.pendingVariantId = String(nextVariant.id);
      setCartError('');
      renderAll();

      return cartRequest('cart/add.js', {
        items: [{
          id: Number(nextVariant.id),
          quantity: line.quantity,
          properties: cartProperties(line, nextDevice)
        }],
        sections: ['mini-cart']
      }).then(function () {
        return fetchCart();
      }).then(function (cartAfterAdd) {
        var currentOldLines = (cartAfterAdd.items || []).filter(function (item) { return cartItemMatchesGroup(item, line); });
        if (!currentOldLines.length) throw new Error('We could not find the original case in your cart.');
        var updates = currentOldLines.reduce(function (lookup, item) {
          lookup[item.key] = 0;
          return lookup;
        }, Object.create(null));
        return cartRequest('cart/update.js', {
          updates: updates,
          sections: ['mini-cart']
        }).catch(function () {
          return removeGroupSequentially(line, currentOldLines.length + 2);
        });
      }).then(function (cart) {
        return reconcileDiscount(cart, cart.sections);
      }).then(function (cart) {
        state.device = nextDevice;
        state.style = 'all';
        state.query = '';
        state.visibleLimit = 12;
        deviceSelect.value = nextDevice;
        saveState();
        renderDeviceOptions();
        return finishCartUpdate(cart, false);
      }).then(function (cart) {
        announce(line.design + ' switched to ' + nextDevice + '.');
        return cart;
      }).catch(function (error) {
        state.cartBusy = false;
        state.pendingVariantId = '';
        return refreshCart(false, false).catch(function () {}).then(function () {
          renderAll();
          setCartError(error.message || 'We could not switch this case. Please try again.');
          return null;
        });
      });
    }
    // Agent END: selected-case phone replacement.

    function openCartReview() {
      if (state.cartBusy) return;
      var miniCart = document.getElementById('mini-cart');
      if (miniCart) miniCart.open = true;
      else window.location.assign(routeUrl('cart'));
    }

    function handleMobileAction() {
      if (!state.device) {
        openDevicePicker(reviewButton, '');
        return;
      }
      if (!state.family) {
        scrollToPick4(familyPicker, 'center');
        var firstFamily = familyTiles.querySelector('[data-filter-family]');
        if (firstFamily) window.setTimeout(function () { firstFamily.focus({ preventScroll: true }); }, 350);
        return;
      }
      openCartReview();
    }

    function handleExternalCartUpdate() {
      if (dispatchingCartEvent || state.cartBusy || !cartEnabled || !document.documentElement.contains(root)) return;
      window.clearTimeout(externalCartRefreshTimer);
      externalCartRefreshTimer = window.setTimeout(function () {
        refreshCart(true, true).catch(function (error) {
          setCartError(error.message || 'We could not refresh your cart. Please reload the page.');
        });
      }, 180);
    }

    root.addEventListener('click', function (event) {
      var zoomButton = event.target.closest('[data-pick4-zoom]');
      if (zoomButton && root.contains(zoomButton)) {
        openImageZoom(zoomButton);
        return;
      }
      var deviceSwitch = event.target.closest('[data-pick4-device-switch]');
      if (deviceSwitch && root.contains(deviceSwitch)) {
        openDevicePicker(
          deviceSwitch,
          deviceSwitch.dataset.pick4LineKey || '',
          deviceSwitch.dataset.pick4ProductId || '',
          deviceSwitch.dataset.pick4Design || ''
        );
        return;
      }
      var familyButton = event.target.closest('[data-filter-family]');
      if (familyButton && root.contains(familyButton)) {
        state.family = familyButton.dataset.filterFamily;
        state.style = 'all';
        state.query = '';
        state.visibleLimit = 12;
        saveState();
        renderAll();
        scrollToPick4(state.device ? postFamily : deviceTrigger, state.device ? 'start' : 'center');
        announce(state.family + ' selected. Style and search filters are now available.');
        return;
      }
      var styleButton = event.target.closest('[data-filter-style]');
      if (styleButton && root.contains(styleButton)) {
        state.style = styleButton.dataset.filterStyle;
        state.visibleLimit = 12;
        saveState();
        renderCatalog();
        return;
      }
      var addButton = event.target.closest('[data-pick4-add]');
      if (addButton && root.contains(addButton)) {
        var closeDrawerAfterAdd = !!(drawer && drawer.open);
        changeQuantity(addButton.dataset.pick4Add, 1).then(function (cart) {
          if (cart && closeDrawerAfterAdd && drawer.open) drawer.close();
        });
        return;
      }
      var quantityButton = event.target.closest('[data-pick4-quantity]');
      if (quantityButton && root.contains(quantityButton)) {
        changeQuantity(quantityButton.dataset.variantId, quantityButton.dataset.pick4Quantity === 'up' ? 1 : -1);
      }
    });

    deviceSelect.addEventListener('change', function () {
      var previousDevice = state.device;
      state.device = deviceSelect.value;
      state.style = 'all';
      state.query = '';
      state.visibleLimit = 12;
      var unavailableFamily = reconcileFamilySelection();
      saveState();
      renderDeviceOptions();
      renderAll();
      if (state.device && state.device !== previousDevice) scrollToPick4(state.family ? postFamily : familyPicker, state.family ? 'start' : 'center');
      if (unavailableFamily) announce(unavailableFamily + ' is not available for ' + state.device + '. Choose another case type.');
    });
    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        state.query = input.value.trim();
        state.visibleLimit = 12;
        saveState();
        renderCatalog();
      });
    });
    deviceTrigger.addEventListener('click', function () { openDevicePicker(deviceTrigger, ''); });
    closeDeviceDialog.addEventListener('click', closeDevicePicker);
    deviceOptions.addEventListener('click', function (event) {
      var option = event.target.closest('[data-pick4-device-option]');
      if (!option) return;
      var targetLine = findLineByKey(deviceChangeTargetKey);
      var nextDevice = option.dataset.pick4DeviceOption;
      closeDevicePicker();
      if (targetLine) switchLineDevice(targetLine, nextDevice);
      else {
        deviceSelect.value = nextDevice;
        deviceSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    deviceDialog.addEventListener('click', function (event) { if (event.target === deviceDialog) closeDevicePicker(); });
    deviceDialog.addEventListener('cancel', function (event) { event.preventDefault(); closeDevicePicker(); });
    deviceDialog.addEventListener('close', function () {
      deviceTrigger.setAttribute('aria-expanded', 'false');
      var focusTarget = deviceReturnFocus && document.documentElement.contains(deviceReturnFocus) ? deviceReturnFocus : deviceTrigger;
      deviceChangeTargetKey = '';
      deviceChangeTargetProductId = '';
      deviceChangeTargetDesign = '';
      deviceReturnFocus = null;
      focusTarget.focus({ preventScroll: true });
    });
    loadMore.addEventListener('click', function () {
      state.visibleLimit += 12;
      renderCatalog();
      announce(pageStatus.textContent);
    });
    openDrawer.addEventListener('click', function () {
      drawer.showModal();
      renderDrawerCatalog();
    });
    closeDrawer.addEventListener('click', function () { drawer.close(); });
    drawer.addEventListener('click', function (event) { if (event.target === drawer) drawer.close(); });
    drawer.addEventListener('cancel', function (event) { event.preventDefault(); drawer.close(); });
    drawer.addEventListener('close', function () {
      drawerGrid.innerHTML = '';
      openDrawer.focus({ preventScroll: true });
    });
    // Agent START: modal close paths match the checkout lightbox and return focus to the zoom control.
    if (closeZoomDialog) closeZoomDialog.addEventListener('click', closeImageZoom);
    if (zoomDialog) {
      zoomDialog.addEventListener('click', function (event) { if (event.target === zoomDialog) closeImageZoom(); });
      zoomDialog.addEventListener('cancel', function (event) { event.preventDefault(); closeImageZoom(); });
      zoomDialog.addEventListener('close', function () {
        var focusTarget = zoomReturnFocus && document.documentElement.contains(zoomReturnFocus) ? zoomReturnFocus : null;
        zoomReturnFocus = null;
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }
    // Agent END: checkout-style lightbox close and focus behavior.
    cartButton.addEventListener('click', openCartReview);
    reviewButton.addEventListener('click', handleMobileAction);
    if (heroCta) heroCta.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToPick4(builderShell, 'start');
    });
    document.documentElement.addEventListener('cart:updated', handleExternalCartUpdate);

    restoreState();
    initializeMobileBarVisibility();
    populateDevices();
    if (reconcileFamilySelection()) saveState();
    renderHero();
    state.cartBusy = true;
    renderAll();
    refreshCart(true, false).catch(function (error) {
      state.cartBusy = false;
      renderAll();
      setCartError(error.message || 'We could not load your cart. Please refresh and try again.');
    });
  }

  function initializeAll() { document.querySelectorAll('[data-pick4-root]').forEach(initPick4); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
/* Agent END: scoped PICK4 builder behavior */
